import React from "react";
import {
  Typography,
  Paper,
  Grid,
  Box
} from "@mui/material";

const ModelCard = ({ model, index }) => {
  const getBadgeColor = (score) => {
    if (score >= 98) return "rgba(34, 197, 94, 0.25)";
    if (score >= 95) return "rgba(59, 130, 246, 0.25)";
    if (score >= 90) return "rgba(234, 179, 8, 0.25)";
    return "rgba(239, 68, 68, 0.25)";
  };

  const images = Array.isArray(model.images)
    ? model.images.filter(img => img)
    : (model.image ? [model.image] : []);

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        mb: 4,
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(10px)",
        borderRadius: 2,
        color: "white"
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" component="h3" sx={{ fontWeight: 700 }}>
          {index + 1}. {model.name}
        </Typography>
        <Box
          sx={{
            ml: 2,
            px: 1.5,
            py: 0.5,
            borderRadius: 10,
            backgroundColor: getBadgeColor(model.overall),
            color: "white",
            fontWeight: 600,
            fontSize: "0.875rem"
          }}
        >
          {model.overall}% Overall
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {model.description}
          </Typography>
        </Grid>

        {images.length > 0 && (
          <Grid item xs={12}>
            {images.map((img, idx) => (
              <Box key={idx} sx={{ mb: 4 }}>
                {model.imageLabels && model.imageLabels[idx] && (
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      fontSize: "15px",
                      color: "white",
                      textAlign: "left"
                    }}
                  >
                    {model.imageLabels[idx]}
                  </Typography>
                )}
                <Box
                  component="img"
                  src={img}
                  alt={`${model.name} - Example ${idx + 1}`}
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    objectFit: "cover"
                  }}
                />
              </Box>
            ))}
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

const ModelComparison = ({ models }) => {
  return (
    <Box>
      {models.map((model, index) => (
        <ModelCard key={model.name} model={model} index={index} />
      ))}
    </Box>
  );
};

export default ModelComparison;